export const ApiResponseFunc = 
{
  methods: 
  {
    apiCatch(error, func = null) 
    {
      let res = error.response;

      if (typeof res != 'undefined' &&
        typeof res.data != 'undefined') 
      {
        
        if(res.status == 401 && this.$route.name != 'Login') 
          this.$router.push('/login')

        if (typeof res.data.code != 'undefined' &&
          typeof res.data.message != 'undefined') 
        {
          return this.$store.commit("OPEN_MODAL", {
            content:res.data.message,
            btnOne:'확인',
            btnOneSubmit: func,
          })
        }

        else if (typeof res.data.message != 'undefined')
        {
          return this.$store.commit("OPEN_MODAL", {
            content: '문제가 발생했습니다. 관리자에게 문의해 주세요.',
            btnOne:'확인',
            btnOneSubmit: func,
          })
        }
      }

      this.$store.commit("OPEN_MODAL", {
        content: '문제가 발생했습니다. 관리자에게 문의해 주세요.',
        btnOne:'확인',
        btnOneSubmit: func,
      })
      
      throw error;
    },

    openPopupMsg(msg){
      return this.$store.commit('OPEN_MODAL', { content: msg, btnOne:'확인',})
    },
    
    openWindow(url) {
      if(window.Android){
        window.Android.browserActivate(url);
      }
      window.open(url); // 새창에서 열림
    },

    callbackPopup(routeName, callbackFunc=null, blank = false) {
      let routeData = this.$router.resolve({name:routeName});
      var popup = null;

      if(blank) popup = window.open(routeData.href, '_blank');
      else popup = window.open(routeData.href, '', "width=400, height=700");

      var popupTick = setInterval(function() {
        if (popup.closed) {
          clearInterval(popupTick);
          console.log('window closed!');
          console.log('callbackFunc',callbackFunc);
          if(callbackFunc) callbackFunc();
        }
      }, 500);
    },

  }
};